module.exports = __webpack_public_path__ + "img/icon-dropdown.3e1856ff.svg";